'use client'

import { Card, CardProps, SxProps, Theme, styled } from '@mui/material'
import { ReactNode } from 'react'
import { DewiColorsDark4, DewiColorsDark8 } from '@styles/tokens/dist/js/tokens'

const StyledCard = styled(Card)({
  background: DewiColorsDark8,
  backgroundColor: DewiColorsDark8,
  border: `1px solid ${DewiColorsDark4}`,
  borderRadius: '1rem',
})

type FormCardProps = {
  children: ReactNode
  sx?: SxProps<Theme>
} & CardProps

export default function FormCard({ children, sx }: FormCardProps) {
  return (
    <StyledCard
      sx={{
        ...sx,
      }}
    >
      {children}
    </StyledCard>
  )
}
